import { api } from "@/lib/axios";

interface ExpenseProps {
  id: string;
  expenseDescription: string;
  expenseAmount: number;
  paidTo: string;
  expenseDate: Date;
  paymentMethod: string;
}

interface ExpensesResponse {
  expenses: ExpenseProps[];
  totalPages: number;
  totalExpenses: number;
  page: number;
}

export async function getExpenses(
  page = 1,
  pageSize = 8,
  month?: number,
  year?: number,
) {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());
  queryParams.append("pageSize", pageSize.toString());

  if (month !== undefined) {
    queryParams.append("month", month.toString());
  }
  if (year !== undefined) {
    queryParams.append("year", year.toString());
  }

  const { data } = await api.get<ExpensesResponse>(
    `/expenses?${queryParams.toString()}`,
  );

  return data;
}
